import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class orderSetupStore {

    // Properties

    @observable orderModalShown = false;
    @observable orderRecommendationModalShown = false;

    @observable spinningOrderSetup = false;
    @observable spinningOrderModal = false;
    @observable spinningOrderRecommendationModal = false;
    
    @observable isCreated = false;

    @observable orderItemDataSources = [];
    @observable orderCategoryDataSources = [];

    @observable orderRecommendationItemDataSources = [];
    @observable orderRecommendationCategoryDataSources = [];

    @observable orderSetups = [];

    @observable orderModalTab = 'item';
    @observable orderRecommendationModalTab = 'item';

    // Initialization

    @action initOrderSetup() {
        this.isCreated = false;
        this.spinningOrderSetup = true;
        return ApiCaller.OrderSetups.apiGetOrderSetups().then((orderSetupResponses) => {
            this.orderSetups = orderSetupResponses;
            this.spinningOrderSetup = false;
        });
    }

    @action initOrderItemDataSource() {
        this.spinningOrderModal = true;
        this.orderModalTab = 'item';
        return ApiCaller.Queries.apiGetQueryOrderItemsForOrderSetup().then((orderItemResponses) => {
            this.orderItemDataSources = orderItemResponses;

            this.spinningOrderModal = false;
        });
    }

    @action initOrderCategoryDataSource() {
        this.spinningOrderModal = true;
        return ApiCaller.Queries.apiGetQueryOrderCategoriesForOrderSetup().then((orderCategoryResponses) => {
            this.orderCategoryDataSources = orderCategoryResponses;

            this.spinningOrderModal = false;
        });
    }

    @action initOrderItemDataSourceForUpdate(orderSetupId) {
        this.orderModalTab = 'item';
        this.spinningOrderModal = true;
        return ApiCaller.Queries.apiGetQueryOrderItemsForOrderSetupForUpdate(orderSetupId).then((orderItemResponses) => {
            this.orderItemDataSources = orderItemResponses;
            this.spinningOrderModal = false;
        });
    }

    @action initOrderCategoryDataSourceForUpdate(orderSetupId) {
        this.spinningOrderModal = true;
        return ApiCaller.Queries.apiGetQueryOrderCategoriesForOrderSetupForUpdate(orderSetupId).then((orderCategoryResponses) => {
            this.orderCategoryDataSources = orderCategoryResponses;
            this.spinningOrderModal = false;
        })
    }

    @action initOrderRecommendationItemDataSource(orderSetupId) {
        this.spinningOrderRecommendationModal = true;
        return ApiCaller.Queries.apiGetQueryOrderRecommendationItemsForOrderSetup(orderSetupId).then((orderRecommendationItemResponses) => {
            this.orderRecommendationItemDataSources = orderRecommendationItemResponses;

            this.spinningOrderRecommendationModal = false;
        })
    }

    @action initOrderRecommendationCategoryDataSource(orderSetupId) {
        this.spinningOrderRecommendationModal = true;
        return ApiCaller.Queries.apiGetQueryOrderRecommendationCategoriesForOrderSetup(orderSetupId).then((orderRecommendationCategoryResponses) => {
            this.orderRecommendationCategoryDataSources = orderRecommendationCategoryResponses;

            this.spinningOrderRecommendationModal = false;
        });
    }

    // READ Action

    // CREATE Action

    @action createOrderSetup(orderCategoryTaskId, orderSubCategoryTaskId, orderTaskId) {
        this.spinningOrderModal = true;

        const orderSetup = {
            'orderCategoryTaskId': orderCategoryTaskId,
            'orderSubCategoryTaskId': orderSubCategoryTaskId,
            'orderTaskId': orderTaskId
        };

        return ApiCaller.OrderSetups.apiCreateOrderSetup(orderSetup).then(() => {
            this.spinningOrderModal = false;
            this.orderModalShown = false;
            this.initOrderSetup();
        });
    }

    @action createOrderRecommendationSetup(orderSetupId, orderRecommendationCategoryTaskId, orderRecommendationSubCategoryTaskId, orderRecommendationTaskId) {
        this.spinningOrderRecommendationModal = true;

        const orderSetup = {
            'orderSetupId': orderSetupId,
            'orderRecommendationCategoryTaskId': orderRecommendationCategoryTaskId,
            'orderRecommendationSubCategoryTaskId': orderRecommendationSubCategoryTaskId,
            'orderRecommendationTaskId': orderRecommendationTaskId
          };

        return ApiCaller.OrderRecommendationSetups.apiCreateOrderRecommendationSetup(orderSetup).then(() => {
            this.initOrderRecommendationItemDataSource(orderSetupId).then(() => {
                this.initOrderRecommendationCategoryDataSource(orderSetupId);
            });
            this.initOrderSetup();
        });
    }

    // UPDATE Action

    @action updateOrderSetup(orderSetupId, orderCategoryTaskId, orderSubCategoryTaskId, orderTaskId) {
        this.spinningOrderModal = true;

        const orderSetup = {
            'orderCategoryTaskId': orderCategoryTaskId,
            'orderSubCategoryTaskId': orderSubCategoryTaskId,
            'orderTaskId': orderTaskId
        };

        return ApiCaller.OrderSetups.apiUpdateOrderSetup(orderSetupId, orderSetup).then(() => {
            this.spinningOrderModal = false;
            this.orderModalShown = false;
            this.initOrderSetup();
        });
    }

    // DELETE Action

    @action deleteOrderSetup(orderSetupId) {
        this.spinningOrderSetup = true;
        return ApiCaller.OrderSetups.apiDeleteOrderSetup(orderSetupId).then(() => {
            this.initOrderSetup();
        });
    }

    @action deleteOrderRecommendationSetup(orderRecommendationSetupId) {
        this.spinningOrderSetup = true;
        return ApiCaller.OrderRecommendationSetups.apiDeleteOrderRecommendationSetup(orderRecommendationSetupId).then(() => {
            this.initOrderSetup();
        });
    }

    @action deleteOrderRecommendationSetupFromModal(orderSetupId, orderRecommendationSetupId) {
        this.spinningOrderRecommendationModal = true;

        return ApiCaller.OrderRecommendationSetups.apiDeleteOrderRecommendationSetup(orderRecommendationSetupId).then(() => {
            this.initOrderRecommendationItemDataSource(orderSetupId);
            this.initOrderRecommendationCategoryDataSource(orderSetupId);
            this.initOrderSetup();
        });
    }

    // SET Properties

    @action setOrderItemDataSources(value) {
        this.orderItemDataSources = value;
    }

    @action setOrderRecommendationItemDataSources(value) {
        this.orderRecommendationItemDataSources = value;
    }

    @action setIsCreated(value) {
        this.isCreated = value;
    }

    @action setOrderModalShown(value) {
        this.orderModalShown = value;
    }

    @action setOrderRecommendationModalShown(value) {
        this.orderRecommendationModalShown = value;
    }

    @action setOrderModalTab(value) {
        this.orderModalTab = value;
    }

    @action setOrderRecommendationModalTab(value) {
        this.orderRecommendationModalTab = value;
    }
}

export default new orderSetupStore()